import React from "react";

interface MarkerDotProps {
  markerPercent?: number; // Wert zwischen 0 und 4
}

const MarkerDot: React.FC<MarkerDotProps> = ({ markerPercent = 0 }) => {
  // Umrechnung: 0-4 → 0-100%
  const percentPosition = (markerPercent / 4) * 100;

  return (
    <svg
      className="marker-dot"
      style={{ left: `${percentPosition}%` }}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={8}
        cy={8}
        r={7}
        fill="#06AFFF"
        stroke="white"
        strokeWidth={2}
      />
    </svg>
  );
};

export default MarkerDot;
